import { useQuery } from '@tanstack/react-query';
import DropshipmentService from '@/services/DropshipmentService';
import { DROPSHIPMENT_KEYS } from './keys';

// Shippable device catalog for a cohort (resolved from the active program's cohortid).
export function useCohortProducts(cohortid: string | number | null | undefined) {
  return useQuery({
    queryKey: DROPSHIPMENT_KEYS.products(cohortid ?? ''),
    queryFn: () => DropshipmentService.getProductsForCohort(cohortid!),
    enabled: cohortid != null && cohortid !== '',
    staleTime: 5 * 60_000,
  });
}

// Shipment history for a patient (the dropshipment `list` call). Refetched after a
// successful order (the mutation invalidates this key).
export function useDeviceOrders(userid: string | number | null | undefined) {
  return useQuery({
    queryKey: DROPSHIPMENT_KEYS.orders(userid ?? ''),
    queryFn: () => DropshipmentService.listOrders(userid!),
    enabled: userid != null && userid !== '',
    staleTime: 30_000,
  });
}

// Address autocomplete suggestions. Fires once the (debounced) query is ≥2 chars;
// placeholderData keeps the previous list visible between keystrokes (no flicker).
export function useAddressSuggestions(query: string, enabled = true) {
  const q = (query ?? '').trim();
  return useQuery({
    queryKey: DROPSHIPMENT_KEYS.addressFind(q),
    queryFn: () => DropshipmentService.addressFind(q),
    enabled: enabled && q.length >= 2,
    staleTime: 60_000,
    placeholderData: (prev) => prev,
  });
}
